module.exports = __webpack_public_path__ + "img/starsbg.3654672a.png";